import React from 'react';
import { Divider, Paper, Typography } from '@material-ui/core';
import { Droppable } from 'react-beautiful-dnd';
import tools from '../../constants/tools';
import Tool from './Tool';

const ToolBox = () => {
    return (
        <div>
            <Droppable
                droppableId="tool-box"
                type="ROW"
                direction="vertical"
                isDropDisabled
            >
                {(provided, snapshot) => (
                    <Paper
                        elevation={0}
                        ref={provided.innerRef}
                        isDraggingOver={snapshot.isDraggingOver}
                    >
                        <Typography variant={'h4'}>Fields</Typography>
                        <Divider style={{ marginBottom: '10px' }} />

                        {Object.keys(tools).map((item, index) => (
                            <Tool
                                key={index}
                                item={tools[item]}
                                index={index}
                            />
                        ))}
                    </Paper>
                )}
            </Droppable>
        </div>
    );
};

export default ToolBox;
